const loginAndSignUp = {
  loginTips: "У вас уже есть учетная запись HitPaw? <1>Войти</1>",
  loginSuccessTips: "Войти успешно",
  loginErrorTips: "Не удалось войти",
  loginAccountOrPasswordErrorTips: "Ваша электронная почта или пароль неверны. Пожалуйста, попробуйте еще раз.",
  loginAccountNotExitErrorTips: "Эта электронная почта не зарегистрирована",
  signUpTips: "Вы еще не зарегистрировались? ",
  rememberMe: "Запомнить пароль",
  forgotPassword: "Забыли пароль?",
  forgotPasswordTitle: "Забыть пароль",
  verifyEmailBtn: "Подтвердить почту",
  resetPasswordTitle: "Сбросить пароль",
  resetPasswordLabel: "Пожалуйста, сбросьте ваш пароль",
  resetPasswordPlaceholder: "Введите новый пароль",
  resetPasswordSuccessTips: "Пароль сброшен успешно",
  signUpPrivacyTips: "Регистрируясь, вы соглашаетесь с нашими <1>Услугами использования</1> и <3>Политикой конфиденциальности.</3>",
  loginPrivacyTips: "Авторизуясь, вы соглашаетесь с нашими <1>Услугами использования</1> и <3>Политикой конфиденциальности</3>",
  signUpSuccessTips: "Ваш аккаунт успешно зарегистрирован！",
  getCode: "Получить код",
  getCodeSuccessTips: "Он был отправлен на вашу почту, пожалуйста, проверьте его",
  verificationSuccessTips: "Электронная почта подтверждена успешно",
  surveyTitle: "Добро пожаловать в HitPaw Онлайн",
  surveyStep1: "<1>Шаг 1</1>/3",
  surveyStep2: "<1>Шаг 2</1>/3",
  surveyStep3: "<1>Шаг 3</1>/3",
  surveyQuestion: "Для чего вы используете HitPaw?",
  surveyThemeQuestion: "Выберите понравившийся вам режим",
  surveyAnswerOther: "Другие",
  surveyAnswer1: "Видео о жизни",
  surveyAnswer2: "Деловое Видео",
  surveyAnswer3: "Видео о компании",
  surveyAnswer4: "Видео о маркетинге",
  surveyAnswer5: "Видео о социальных сетях",
  surveyAnswer6: "Видео о Слайд-шоу",
  surveyAnswer7: "Видеоинструмент",
  surveyAnswer8: "Видео о путешествиях",
  surveyAnswer9: "Видео о свадьбе",
  surveyAnswer10: "Видео о Дне рождения",
  surveyAnswer11: "Видео о детях",
  surveyAnswer12: "Видео о животных",
  surveyAnswer13: "Видео о еде",
  surveyAnswer14: "Видео о моде",
  surveyAnswer15: "Видео о празднике",
  surveyAnswer16: "Видео о спорте",
  surveyAnswer17: "Видео о фотографии",
  surveyAnswer18: "Видео о музыке",
  surveyAnswerLightMode: "Светлый режим",
  surveyAnswerDarkMode: "Темный режим",
  surveyNextBtn: "Далее",
  surveyBackBtn: "Назад",
  surveyDoneBtn: "Готово",
  surveyStartBtn: "Начните",
  logoutWarnTips: "Вы уверены, что выйти из системы?",
};

export default loginAndSignUp;
